import Gallery from "../../clubAdmin/gallery/ParentAdminGallery";
import ListMembers from "../../clubAdmin/members/List";
import ParentAdminPolls from "../../clubAdmin/ParentAdminPolls/ParentAdminPolls";
import ClubAdminChants from "../../clubAdmin/chants/ClubAdminChants";
import { Navigate } from "react-router-dom";
import HelpPage from "../../admin/help/HelpPage";
import ParentAdminGroups from "../../clubAdmin/groups/ParentAdminGroups";
import ClubMembershipCard from "../../clubAdmin/MembershipCard/ClubMembershipCard";
import ParentAdminMembers from "../../clubAdmin/members/ParentAdminMembers";
import ParentAdminContent from "../../clubAdmin/contents/ParentAdminContent";
import CreateChants from "../../admin/content/chants/CreateChants";
import CreateAdminGiveaway from "../../admin/content/AdminGiveaways/CreateAdminGiveaway/CreateGiveaway";
import CreatePoll from "../../admin/content/AdminPolls/CreatePoll/CreatePoll";
import ParentAdminLocations from "../../clubAdmin/locations/ParentAdminLocations";
import CreateLocations from "../../admin/locations/CreateLocation/CreateLocations";
import EventForm from "../../admin/content/Events/EventForm/EventForm";
import ParentAdminGiveaways from "../../clubAdmin/giveaways/ParentAdminGiveaways";
import ParentAdminGiveawayEntries from "../../clubAdmin/giveaways/ParentAdminGiveawayEntries";

export const parentAdminRoutes = [
  { path: "/clubadmin/groups", element: <ParentAdminGroups /> },
  {
    path: "/clubadmin/groups/:id/members",
    element: <ListMembers />,
  },
  { path: "/clubadmin/:groupId?/members", element: <ParentAdminMembers /> },

  { path: "/clubadmin/content", element: <ParentAdminContent /> },

  // Events
  {
    path: "/clubadmin/content/:mode/:group?/:id?",
    element: <EventForm />,
  },

  // Locations
  {
    path: "/clubadmin/content/locations",
    element: <ParentAdminLocations />,
  },
  {
    path: "/clubadmin/content/locations/create",
    element: <CreateLocations />,
  },
  {
    path: "/clubadmin/content/locations/edit/:id",
    element: <CreateLocations />,
  },

  // Gallery
  { path: "/clubadmin/gallery", element: <Gallery /> },

  // Giveaways
  { path: "/clubadmin/giveaways", element: <ParentAdminGiveaways /> },
  {
    path: "/clubadmin/giveaways/create",
    element: <CreateAdminGiveaway />,
  },
  {
    path: "/clubadmin/giveaways/edit/:giveawayId",
    element: <CreateAdminGiveaway />,
  },
  {
    path: "/clubadmin/giveaways/:giveawayId",
    element: <ParentAdminGiveawayEntries />,
  },

  // Polls
  { path: "/clubadmin/polls", element: <ParentAdminPolls /> },
  { path: "/clubadmin/polls/create", element: <CreatePoll /> },
  { path: "/clubadmin/polls/edit/:pollId", element: <CreatePoll /> },

  // Chants
  { path: "/clubadmin/chants", element: <ClubAdminChants /> },
  { path: "/clubadmin/chants/archive", element: <ClubAdminChants /> },
  { path: "/clubadmin/chants/create", element: <CreateChants /> },
  {
    path: "/clubadmin/chants/edit/:group/:id",
    element: <CreateChants />,
  },

  // Help
  { path: "/clubadmin/help", element: <HelpPage /> },

  // Membership
  {
    path: "/clubadmin/membership",
    element: <ClubMembershipCard />,
  },
  {
    path: "/login",
    element: <Navigate to="/clubadmin/groups" replace />,
  },
  { path: "/", element: <Navigate to="/clubadmin/groups" replace /> },
];
